// src/components/admin/topnavbar/TopNavbar.jsx
import React, { useState, useRef, useEffect } from 'react';
import { 
  FiMenu, FiSearch, FiChevronDown, FiUser, 
  FiSettings, FiLogOut, FiX 
} from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../../assets/css/superadmin/topnavbar/TopNavbar.css';
 
const TopNavbar = ({ onToggleSidebar, isSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const dropdownRef = useRef(null);

  // Updated routes based on sidebar image
  const getPageTitle = () => {
    const path = location.pathname;
    
    // Main routes
    if (path === '/admin/dashboard') return 'Dashboard';
    if (path === '/admin/sub-admin') return 'Sub-admin';
    if (path === '/admin/category') return 'Category';
    
    // User Management routes
    if (path === '/admin/users') return 'User Management';
    if (path === '/admin/users/rental-management') return 'Rental Management';
    if (path === '/admin/users/mechanic-management') return 'Mechanic Management';
    if (path === '/admin/users/user-management') return 'User Management';
    
    // Other routes
    if (path === '/admin/maintenance-request') return 'Maintenance Request';
    if (path === '/admin/equipment-listing') return 'Equipment Listing';
    if (path === '/admin/earning') return 'Earning';
    if (path === '/admin/rating-review') return 'Rating & Review';
    if (path === '/admin/reports-analytics') return 'Report & Analytics';
    if (path === '/admin/disputes') return 'Disputes';
    if (path === '/admin/support-help') return 'Support & Help';
    if (path === '/admin/blogs') return 'Blogs';
    if (path === '/admin/settings') return 'Settings';
    if (path === '/admin/profile') return 'Profile';
    if (path === '/admin/notification') return 'Notifications';
    
    return 'Dashboard';
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleProfile = () => {
    navigate('/admin/profile');
    setIsDropdownOpen(false);
  };

  const handleSettings = () => {
    navigate('/admin/settings');
    setIsDropdownOpen(false);
  };

  const handleLogout = () => {
    navigate('/admin/logout');
    setIsDropdownOpen(false);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/admin/search?q=${searchQuery}`);
    }
  };

  return (
    <nav className="smart-agri-topnavbar">
      <div className="smart-agri-topnavbar-left">
        {/* Hamburger Menu */}
        <button 
          className="smart-agri-hamburger-btn" 
          onClick={onToggleSidebar}
          aria-label="Toggle Sidebar"
        >
          {isSidebarOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>

        {/* Page Title */}
        <h1 className="smart-agri-page-title">{getPageTitle()}</h1>
      </div>

      <div className="smart-agri-topnavbar-right">
        {/* Search Bar */}
        <form className="smart-agri-search-container" onSubmit={handleSearch}>
          <FiSearch className="smart-agri-search-icon" />
          <input
            type="text"
            className="smart-agri-search-input"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </form>

        {/* Admin Profile Dropdown */}
        <div className="smart-agri-profile-container" ref={dropdownRef}>
          <button 
            className="smart-agri-profile-btn" 
            onClick={handleDropdownToggle}
            aria-label="Admin Menu"
          >
            <div className="smart-agri-avatar">A</div>
            <span className="smart-agri-name">Admin</span>
            <FiChevronDown 
              className={`smart-agri-chevron-icon ${isDropdownOpen ? 'rotate' : ''}`} 
              size={18} 
            />
          </button>

          {/* Dropdown Menu */}
          {isDropdownOpen && (
            <div className="smart-agri-dropdown">
              <div className="smart-agri-dropdown-header">
                <div className="smart-agri-dropdown-avatar">A</div>
                <div className="smart-agri-dropdown-info">
                  <h4 className="smart-agri-dropdown-name">Admin Panel</h4>
                  <p className="smart-agri-dropdown-email">admin@smartagrirent.com</p>
                </div>
              </div>
              
              <div className="smart-agri-dropdown-divider"></div>
              
              {/* <button className="smart-agri-dropdown-item" onClick={handleProfile}>
                <FiUser size={18} />
                <span>Profile</span>
              </button> */}

              <button className="smart-agri-dropdown-item" onClick={handleSettings}>
                <FiSettings size={18} />
                <span>Settings</span>
              </button>
              
              <div className="smart-agri-dropdown-divider"></div>
{/*               
              <button className="smart-agri-dropdown-item logout" onClick={handleLogout}>
                <FiLogOut size={18} />
                <span>Logout</span>
              </button> */}
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default TopNavbar;